import React from 'react' // eslint-disable-line no-unused-vars
import Select from '../forms/Select'
import InputGroup from '../forms/InputGroup'
import { validateField, submitForm } from '../pages/functions'
import { connect } from 'react-redux'
import { ABBVIE_EMPLOYEE, HCP } from '../constants'
import CountryAwareComponent from '../mi-app/CountryAwareComponent'
import StaticConfig from '../mi-app/StaticConfig'
import { isMobileDevice } from '../functions.js'
import { CircularProgress } from '@material-ui/core'
/* There are currently no language-specific rules for this form */
// import { formFieldsPerLanguage } from './language/FormFieldsPerLanguage'

class FindMyMSLForm extends CountryAwareComponent {
  constructor (props) {
    super(props)

    this.handleClearSearchResult = this.props.clearSearchResult

    const languageContent = this.props.pageContent.content
    this.componentName = 'FindMyMSLForm'
    var fields = {
      therapeuticArea: {
        name: 'therapeuticArea',
        value: '',
        rules: {
          title: languageContent.module.findMyMSL.therapeuticArea,
          required: true 
        }
      },
      subTherapeuticArea: {
        name: 'subTherapeuticArea',
        value: '',
        rules: {
          title: languageContent.module.findMyMSL.subTherapeuticArea,
          required: false,
          ignoreNull: true 
        }
      },
      diseaseState: {
        name: 'diseaseState',
        value: '',
        rules: {
          title: languageContent.module.findMyMSL.diseaseState,
          required: false,
          ignoreNull: true
        }
      },
      zipAreaCode: {
        name: 'zipAreaCode',
        value: '',
        rules: {
          title: languageContent.module.findMyMSL.zipAreaCode,
          required: true,
          format: {
            regex: /^((-?\d{1,5})|E|ER|ERR|ERRO|ERROR)$/,
            message: languageContent.module.findMyMSL.invalidZip
          }
        }
      }
    }


    this.therapeuticAreaOptions = languageContent.module.findMyMSL.therapeuticAreaSearchOptions
    
    this.state = { 
      fields,
      subTherapeuticAreaOptions: [],
      diseaseStateOptions: []
     }

    /* There are currently no language-specific rules for this form */
    // formFieldsPerLanguage(this.state.fields, this.props.pageContent.content)

    this.searchCriteria = {}
    this.validateTherapeuticArea = this.validateTherapeuticArea.bind(this)
    this.validateSubTherapeuticArea = this.validateSubTherapeuticArea.bind(this)
    this._validate = this._validate.bind(this)
    this._submit = this._submit.bind(this)
  }

  /* 
   * There are currently no language-specific rules for this form
   * NOTE: componentWillReceiveProps has been deprecated.  Replace with componentDidUpdate if needed
  */
  // componentWillReceiveProps (nextProps) {
  //   formFieldsPerLanguage(this.state.fields, nextProps.pageContent.content)
  // }

  _selectOnlyOptionOrNone(options) {
    return !options ? '' : options.length === 1 ? options[0].value : ''
  }


  validateTherapeuticArea (e) {
    const MSLContent = this.props.pageContent.content.module.findMyMSL
    const subTherapeuticAreaOptions = MSLContent.subTherapeuticAreaSearchOptions[e.target.value] || []
    const diseaseStateKey = `${e.target.value}_`
    const diseaseStateOptions = MSLContent.diseaseStateSearchOptions[diseaseStateKey] || []

    const field = this.state.fields.therapeuticArea;
    const fields = validateField(e, field, this.state.fields)
    fields.subTherapeuticArea.value = this._selectOnlyOptionOrNone(subTherapeuticAreaOptions);
    fields.subTherapeuticArea.errors = []
    fields.subTherapeuticArea.rules.required = subTherapeuticAreaOptions.length > 0
    fields.subTherapeuticArea.rules.ignoreNull = subTherapeuticAreaOptions.length === 0
    fields.diseaseState.value = this._selectOnlyOptionOrNone(diseaseStateOptions)
    fields.diseaseState.errors = []
    fields.diseaseState.rules.required = diseaseStateOptions.length > 0
    fields.diseaseState.rules.ignoreNull = diseaseStateOptions.length === 0

    this.setState({
      fields,
      subTherapeuticAreaOptions,
      diseaseStateOptions
    })
  }

  validateSubTherapeuticArea (e) {
    const field = this.state.fields.subTherapeuticArea;
    const fields = validateField(e, field, this.state.fields)
    const MSLContent = this.props.pageContent.content.module.findMyMSL
    const diseaseStateKey = `${fields.therapeuticArea.value}_${e.target.value}`
    const diseaseStateOptions = MSLContent.diseaseStateSearchOptions[diseaseStateKey] || []

    fields.diseaseState.value = this._selectOnlyOptionOrNone(diseaseStateOptions)
    fields.diseaseState.errors = []
    fields.diseaseState.rules.required = diseaseStateOptions.length > 0
    fields.diseaseState.rules.ignoreNull = diseaseStateOptions.length === 0

    this.setState({
      fields,
      diseaseStateOptions
    })

  }

  _validate (e, field) {
    var fields = validateField(e, field, this.state.fields)

    this.setState({ fields })

    return false
  }

  _submit (e) {
    const fields = submitForm(e, this.state.fields)

    this.setState({ fields })

    for (var key in fields) {
      if (fields[key].errors.length > 0) {
        return false
      }
    }

    this.props.submit({
      therapeuticArea: this.state.fields.therapeuticArea.value,
      subTherapeuticArea: this.state.fields.subTherapeuticArea.value || '',
      diseaseState: this.state.fields.diseaseState.value || '',
      zipAreaCode: this.state.fields.zipAreaCode.value,
      country:
        StaticConfig.Context.UserType === ABBVIE_EMPLOYEE
          ? StaticConfig.Context.ssoCountry.name
          : StaticConfig.Context.Country.name,
      searchUserType: StaticConfig.Context.UserType
    })
  }

  isSearchButtonDisabled = () => {
    return !this.state.fields.therapeuticArea.value ||
           !this.state.fields.zipAreaCode.value ||
           (this.state.fields.zipAreaCode.errors && this.state.fields.zipAreaCode.errors.length) ||
           (this.state.fields.subTherapeuticArea.rules.required && !this.state.fields.subTherapeuticArea.value) ||
           (this.state.fields.diseaseState.rules.required && !this.state.fields.diseaseState.value)
  }

  render () {
    const languageContent = this.props.pageContent.content

    if (this.props.parentMethod) this.props.parentMethod()
    const jsx = (
      <form
        onSubmit={e => {
          e.preventDefault()
          this._submit(e)
        }}
      >
        <div className='findmymsl-form'>
          <div className='row'>
            <div className='col-lg-10'>
              <p
                className='text-left subtitle'
              >{languageContent.module.findMyMSL.helperText}
              </p>
            </div>
            <div className='col-lg-2'>
              <p className='text-right subtitle required-indic'>
                <strong>*{languageContent.module.findMyMSL.required}</strong>
              </p>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-6'>
              <div>
                <Select
                  id='therapeuticArea'
                  searchable
                  clearable
                  options={this.therapeuticAreaOptions}
                  field={this.state.fields.therapeuticArea}
                  validate={this.validateTherapeuticArea}
                  onChange={this.handleClearSearchResult}
                />
              </div>
              {
                this.state.subTherapeuticAreaOptions.length > 0 &&
                <div className='mt-4'>
                  <Select
                    id='subTherapeuticArea'
                    searchable
                    clearable
                    options={this.state.subTherapeuticAreaOptions}
                    field={this.state.fields.subTherapeuticArea}
                    validate={this.validateSubTherapeuticArea}
                    onChange={this.handleClearSearchResult}
                  />
                </div>
              }
              {
                this.state.diseaseStateOptions.length > 0 &&
                <div className='mt-4'>
                  <Select
                    id='diseaseState'
                    searchable
                    clearable
                    options={this.state.diseaseStateOptions}
                    field={this.state.fields.diseaseState}
                    validate={(e) => this._validate(e, this.state.fields.diseaseState)}
                    onChange={this.handleClearSearchResult}
                  />
                </div>
              }
            </div>
            <div className='col-lg-2 mt-3 mt-lg-0'>
              <InputGroup
                field={this.state.fields.zipAreaCode}
                onKeyDown={event => {
                  if (StaticConfig.Context.UserType === HCP && event.key === '*') {
                    event.preventDefault()
                  }
                }}
                validate={(e) => this._validate(e, this.state.fields.zipAreaCode)}
                onChange={this.handleClearSearchResult}
              />
            </div>
          </div>
          <div className='row mt-4'>
            <div className={`col-xl-1 ${isMobileDevice() ? '' : 'm-b-20'} text-left`}>
              <button
                id='searchBtn'
                type='submit'
                style={{ cursor: 'pointer' }}
                className={`btn ${!this.isSearchButtonDisabled() ? 'btn-info' : 'btn-info-no-hover'} btn-lg-wide submit-button btn-rounded`}
                disabled={this.isSearchButtonDisabled()}
              >
              {
                  this.props.searching
                    ? <div className='loading-text-centered'>
                    <span>{languageContent.module.findMyMSL.search}</span>
                        <span className='loading-progress-centered'><CircularProgress size={24}/></span>
                      </div>
                    : <React.Fragment>{languageContent.module.findMyMSL.search}</React.Fragment>
                }
              </button>
            </div>
          </div>
        </div>
      </form>
    )
    return this.countriesMatched() ? jsx : null
  }
}

function mapStateToProps (state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent,
    permissions: state.permissions
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(
  FindMyMSLForm
)



// WEBPACK FOOTER //
// ./src/mi-app/FindMyMSLForm.js